import apiUrl from "./config/config";
import axios from "axios";

class productFileApi
{

  //Get a productFile 
  static async getProductFile(id)
  {

    try
    {

      const response = await axios(apiUrl + `productfile/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get all productFiles
  static async getProductFiles(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "productfile", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }


  //Update a productFile
  static async updateProductFile(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "productfile", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete a productFile
  static async deleteProductFile(id)
  {

    try
    {

      const response = await axios.delete(apiUrl + `productfile/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Get a processFile 
  static async downloadProductFile(id)
  {

    try
    {

      const response = await axios(apiUrl + `productfile/download/${id}`, {
        responseType: 'arraybuffer'
      });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }


}

export default productFileApi;
